import { createAsyncThunk } from '@reduxjs/toolkit'
import { fetchPublicProfileData } from 'shared/api/fetchPublicProfileData'

export const fetchOtherProfileData = createAsyncThunk(
    'profile/fetchOtherProfileData',
    async (handle) => {
        const profile = await fetchPublicProfileData(handle)
        if (!profile) return null

        const normalizedProfile = { createdMoments: [], ...profile }
        if (normalizedProfile.authTime?.firstAuth?.seconds !== undefined) {
            normalizedProfile.authTime = {
                ...normalizedProfile.authTime,
                firstAuth: +new Date(
                    normalizedProfile.authTime.firstAuth.seconds
                ),
                lastAuth: +new Date(
                    normalizedProfile.authTime.lastAuth.seconds
                ),
            }
        }
        return [normalizedProfile]
    }
)
